<template>
  <layout-mobile>
    <div class="comms_filter flex flex-end">
      <comms-filters></comms-filters>
    </div>

    <comms-list></comms-list>
  </layout-mobile>
</template>

<script>
import CommsFilters from "./components/CommsFilters";
import CommsList from "./components/CommsList";

export default {
  name: "CommsPageMobile",
  components: {
    CommsList,
    CommsFilters
  },
}
</script>

<style lang="scss" scoped>
@import "../../styles/variables/variables";

.comms_filter {
  margin-right: -10px; // to counteract default filter margin
}
</style>
